<script setup lang="ts">
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  import type { BadgeVariants } from '.';
  import { badgeVariants } from '.';

  const props = defineProps<{
    variant?: BadgeVariants['variant'];
    class?: HTMLAttributes['class'];
    size?: BadgeVariants['size'];
    rounded?: boolean;
    outline?: boolean;
    dashed?: BadgeVariants['dashed'];
  }>();
</script>

<template>
  <div
    :class="
      cn(
        badgeVariants({
          size,
          variant,
          rounded,
          outline,
          dashed,
        }),
        props.class,
      )
    "
  >
    <slot />
  </div>
</template>
